import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Scale } from "lucide-react";

const LOGO_FULL = "https://customer-assets.emergentagent.com/job_direito-trabalho-sp/artifacts/0oicyq69_FullLogo_Transparent_NoBuffer.png";

const Footer = () => {
  const areasDeAtuacao = [
    { label: "Direito do Trabalho", path: "/direito-trabalhista" },
    { label: "Direito Tributário", path: "/direito-tributario" },
    { label: "Direito Imobiliário", path: "/direito-imobiliario" },
    { label: "Direito Previdenciário", path: "/direito-previdenciario" },
    { label: "Direito Cível", path: "/direito-civel" },
    { label: "Direito de Família", path: "/direito-familia" },
    { label: "Direito Penal", path: "/direito-penal" },
  ];

  return (
    <footer className="bg-gray-900 text-gray-300" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src={LOGO_FULL}
              alt="Helio Lopes Leal Advocacia"
              className="h-12 w-auto mb-6 invert"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Advocacia estratégica e consultoria jurídica. 
              Atuação técnica e personalizada para pessoas e empresas.
            </p>
            <div className="flex items-center gap-2 text-sm">
              <Scale className="w-4 h-4 text-blue-400" />
              <span className="text-gray-400">OAB/SP 396.732</span>
            </div>
            <p className="text-xs text-gray-500 mt-1">CNPJ: 62.842.035/0001-25</p>
          </div>

          {/* Áreas de Atuação */}
          <div>
            <h4 className="text-white font-semibold mb-6 text-sm tracking-wider">ÁREAS DE ATUAÇÃO</h4>
            <ul className="space-y-3">
              {areasDeAtuacao.map((area) => (
                <li key={area.path}>
                  <Link
                    to={area.path}
                    className="text-gray-400 hover:text-white transition-colors text-sm"
                  >
                    {area.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Institucional */}
          <div>
            <h4 className="text-white font-semibold mb-6 text-sm tracking-wider">INSTITUCIONAL</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/sobre" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Sobre o Escritório
                </Link>
              </li>
              <li>
                <Link to="/contato" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Contato
                </Link>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h4 className="text-white font-semibold mb-6 text-sm tracking-wider">CONTATO</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-blue-400 flex-shrink-0" />
                <div>
                  <p className="text-gray-400">(11) 91761-1575</p>
                  <p className="text-xs text-gray-500">WhatsApp disponível</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-blue-400 flex-shrink-0" />
                <span className="text-gray-400">h.lopesleal@adv.oabsp.org.br</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-blue-400 flex-shrink-0" />
                <div>
                  <p className="text-gray-400">
                    Rod. Pres. Tancredo de Almeida Neves, 2134, Sala 01
                  </p>
                  <p className="text-gray-400">Caieiras/SP</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-gray-500">
              © {new Date().getFullYear()} Helio Lopes Leal Advocacia e Consultoria. Todos os direitos reservados.
            </p>
            <p className="text-xs text-gray-600 max-w-lg text-center md:text-right">
              Este site tem caráter informativo e não constitui promessa de resultado. 
              A atuação advocatícia observa o Código de Ética e Disciplina da OAB.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
